import EditControlModal from '@modules/widgets/forms/CommandButton/EditControlModal';
import useMenu from '../menu/useMenu';

export default function useValueTextMenu({ property, object }) {
  const items = useMenu();

  return [
    items.genMenuEditItem({
      title: 'Edit text',
      handleAction: () => {
        EditControlModal({
          widgetId: object.id,
          propId: property.id,
          propKey: property.key,
        })
          .then()
          .catch(() => {});
      },
    }),
    items.genMenuShowHistory({
      disabled: true,
    }),
  ];
}
